module.exports = __webpack_public_path__ + "img/32.3bbf91b5.png";